import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_Artifact, } from './db-def.js';
export const ApiDef_Artifact = {
    _v1: {
        'register-version': { method: HttpMethod.POST, path: `v1/${DBDef_Artifact.dbKey}/register-version` },
        'check-version-exists': { method: HttpMethod.POST, path: `v1/${DBDef_Artifact.dbKey}/check-version-exists` },
        'get-artifact-data-by-facility': {
            method: HttpMethod.POST,
            path: `v1/${DBDef_Artifact.dbKey}/get-artifact-data-by-facility`
        },
        'get-artifact-data-by-version': {
            method: HttpMethod.POST,
            path: `v1/${DBDef_Artifact.dbKey}/get-artifact-data-by-version`
        },
        'get-artifact-backup-path': {
            method: HttpMethod.POST,
            path: `v1/${DBDef_Artifact.dbKey}/get-artifact-backup-path`
        },
        'get-latest-artifact-version': { method: HttpMethod.GET, path: `v1/${DBDef_Artifact.dbKey}/get-latest-artifact-version` },
        'set-latest-artifact-version': { method: HttpMethod.POST, path: `v1/${DBDef_Artifact.dbKey}/set-latest-artifact-version` },
        'trigger-artifact-pipeline': { method: HttpMethod.POST, path: `v1/${DBDef_Artifact.dbKey}/trigger-artifact-pipeline` },
    }
};
//# sourceMappingURL=api-def.js.map